import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineEditIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M21 12a1.0001 1.0001 0 0 0-1 1v6a1.0001 1.0001 0 0 1-1 1H5a1.0002 1.0002 0 0 1-1-1V5a1 1 0 0 1 1-1h6a1 1 0 1 0 0-2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6a1.0001 1.0001 0 0 0-1-1Zm-15 .76V17a1 1 0 0 0 1 1h4.24a1.0003 1.0003 0 0 0 .71-.29l6.92-6.93L21.71 8a1.001 1.001 0 0 0 .2958-.71.9994.9994 0 0 0-.2958-.71l-4.24-4.29a1.001 1.001 0 0 0-.71-.2958 1.0003 1.0003 0 0 0-.71.2958l-2.82 2.83-6.94 6.93a1 1 0 0 0-.29.71Zm10.76-8.35 2.83 2.83-1.42 1.42-2.83-2.83 1.42-1.42ZM8 13.17l5.93-5.93 2.83 2.83L10.83 16H8v-2.83Z"/>
  </SvgIcon>
}

export default LineEditIcon
